import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import forms from "../../../../Data/Forms/Projects/Gallery/forms";
import headers from "../../../../Data/Forms/Projects/Gallery/headers";
import {
  create_project_gallery,
  get_project_gallery,
  update_project_gallery,
} from "../../../../Controllers/Projects/Gallery";
import Header from "../../../../Components/Header";
import Form from "../../../../Components/Form";
import Loadercomponent from "../../../../Components/Loader";
import { convert_to_file } from "../../../../Controllers/Global";

const ProjectsGalleryForm = () => {
  let { id } = useParams();

  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [values, setValues] = useState(forms);

  const formdata = async (data) => {
    if (data?.status) {
      setButtonLoader(true);

      const gallery = id
        ? await update_project_gallery({ id: id, ...data?.data })
        : await create_project_gallery(data?.data);

      if (gallery?.status) {
        if (id) {
          navigate(-1);
        }
        toast?.success(gallery?.message);
        setButtonLoader(false);
      } else {
        toast?.error(gallery?.message);
        setButtonLoader(false);
      }
    }
  };

  const handleData = async (gallery) => {
    let image = gallery?.image ? gallery?.image : "";
    let file = await convert_to_file(image);
    let name = gallery?.name ? gallery?.name : "";
    let status = gallery?.status ? gallery?.status : 0;

    forms[0].options[0].form.value = [file];
    forms[0].options[1].form.value = name;
    forms[0].options[2].form.value = status;

    setLoader(false);
    setValues([...values]);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      headers.navigate.path[1].name = "Edit";

      const data = {
        id: id,
      };

      const gallery = await get_project_gallery(data);

      if (gallery?.status) {
        await handleData(gallery?.data);
      } else {
        toast?.error(gallery?.message);
      }
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [buttonLoader]);

  return (
    <Header header={headers}>
      <Loadercomponent loader={loader}>
        <Form
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
        />
      </Loadercomponent>
    </Header>
  );
};

export default ProjectsGalleryForm;
